import RecordedCallsResource from 'flow/api/recordedcalls';
import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';
import { TranscriptionExtended } from 'flow/types/CallRecord';
import { ExtendedTranscriptionKey } from 'flow/types/EntityKeys';

export const useGetExtendedTranscription = (
    extendedTranscriptionKey: ExtendedTranscriptionKey | undefined,
    transcriptionIsPending: boolean | undefined,
    personal: boolean | undefined,
) => {
    return useAuthenticatedQuery({
        queryKey: ['extendedTranscription', extendedTranscriptionKey, personal],
        queryFn: () =>
            new Promise<TranscriptionExtended>((resolve, reject) => {
                RecordedCallsResource.fetchExtendedTranscription(
                    {
                        onResult: resolve,
                        onError: reject,
                        onClientError: reject,
                    },
                    extendedTranscriptionKey,
                    personal,
                );
            }),
        enabled: !!extendedTranscriptionKey && !transcriptionIsPending,
        retry: false,
    });
};
